<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}
      </div>
      <router-link class="btn-blue" to="raw-materials-categories"
        >{{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}
        {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="rmc_category"
                name="rawmaterialcategory"
                id="rawmaterialcategory"
                v-validate="'required|max:200'"
                v-b-tooltip.hover.top="'rawmaterial_tooltip'"
              />
              <label
                >{{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}</label
              >
            </div>
            <!-- <Tooltip :title="$t('rawmaterial_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('rawmaterialcategory')">{{
              errors.first("rawmaterialcategory")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="rmc_is_active"
              type="checkbox"
              class="j-checkbox ml-2"
              checked
            />
            <!-- <span class="switch-slider"></span> -->
            <!-- </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="raw-materials-categories"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
export default {
  components: { Multiselect },
  data() {
    return {
      submitted: false,
      btenable: false,
      rmc_category: "",
      rmc_is_active: true,
      BaseURL: "",
    };
  },
  mounted() {
    // this.getVendorsList();
  },
  methods: {
    onResetForm: function () {
      this.rmc_category = "";
      this.rmc_is_active = true;
    },
    onFinalSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          let payload = {
            rmc_category: this.rmc_category,
            rmc_is_active: this.rmc_is_active,
          };
          PosFnbService.AddRawMaterialCategory(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$validator.reset();
                this.$toasted.show(data.message);
                this.onResetForm();
                if (flag) {
                  this.$router.push({
                    path: "raw-materials-categories",
                  });
                  this.$toasted.show(data.message);
                }
                //  else {
                //   this.$router.push({
                //     path: "food-categories"
                //   });
                // }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RawMaterialCategoriesComponents/addRawMaterialCategories.vue